import { Box } from '@mui/material';
import React from 'react';
import HeaderNotifications from './notification/Notification';

function HeaderButtons() {
    return (
        <Box sx={{ mr: 1 }}>
            <Box sx={{ mx: 0.5 }} component="span">
                <HeaderNotifications></HeaderNotifications>
            </Box>
        </Box>
    );
}

export default HeaderButtons;
